import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/ui/Button';
import Card from '../../components/ui/Card';
import { useAuth } from '../../contexts/AuthContext';
import { isTeacher } from '../../utils/firebase';

const MafiaGame: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const isTeacherUser = currentUser && isTeacher(currentUser);

  return (
    <div style={{ maxWidth: 960, margin: '0 auto', padding: '32px 24px' }}>
      <h1 style={{ textAlign: 'center', marginBottom: 8, fontSize: 24, fontWeight: 700 }}>
        마피아 게임
      </h1>
      <p style={{ textAlign: 'center', color: '#666', marginBottom: 32 }}>
        구스구스덕 현실판! 역할을 배정받고 게임을 즐기세요.
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 24 }}>
        {isTeacherUser && (
          <Card
            padding="32px"
            onClick={() => navigate('/tools/mafia-game/create')}
            style={{ cursor: 'pointer', textAlign: 'center' }}
          >
            <div style={{ fontSize: 48, marginBottom: 16, color: 'var(--Color-fill-brand-color)' }}>➕</div>
            <h2 style={{ marginBottom: 8, fontSize: 20, fontWeight: 600 }}>게임 방 생성</h2>
            <p style={{ color: '#666', fontSize: 14 }}>교사용: 게임 방을 만들고 학생들을 초대하세요</p>
          </Card>
        )}
        <Card
          padding="32px"
          onClick={() => navigate('/tools/mafia-game/join')}
          style={{ cursor: 'pointer', textAlign: 'center' }}
        >
          <div style={{ fontSize: 48, marginBottom: 16, color: 'var(--Color-fill-brand-color)' }}>👤</div>
          <h2 style={{ marginBottom: 8, fontSize: 20, fontWeight: 600 }}>게임 참가</h2>
          <p style={{ color: '#666', fontSize: 14 }}>초대 코드로 게임에 참가하세요</p>
        </Card>
      </div>

      <div style={{ padding: 24, marginTop: 32, backgroundColor: '#e3f2fd', borderRadius: 8 }}>
        <h2 style={{ marginBottom: 12, fontSize: 18 }}>게임 방법</h2>
        <ol style={{ margin: 0, paddingLeft: 20, color: '#333' }}>
          <li>교사가 게임 방을 생성하고 초대 코드를 공유합니다</li>
          <li>학생들이 초대 코드로 게임에 참가합니다</li>
          <li>교사가 역할을 랜덤으로 배정합니다</li>
          <li>각자 역할을 확인하고 게임을 시작합니다</li>
        </ol>
      </div>
    </div>
  );
};

export default MafiaGame;
